import { EffectCallback, useEffect, useRef } from "react";

/** Runs the initial version of an effect exactly once when a component mounts. */
export function useOnMount(effect: EffectCallback): void {
  const initialEffect = useRef(effect);

  useEffect(() => initialEffect.current(), []);
}
